import Notifier from 'common/helpers/Notifier';
import { isHttpSuccess } from 'src/api/utils/httpStatus';
import { coreApi } from 'src/api/config';

const updateContactPreferences = async (contactPreferencesId, contactPreferences) => {
  try {
    const response = await coreApi.updateRecord('contact_preference', contactPreferencesId, contactPreferences);

    if (!response || !isHttpSuccess(response.status)) {
      Notifier.handleErrors(response);
      return false;
    }

    return response;
  } catch (error) {
    Notifier.handleErrors(error);
    return false;
  }
};

export default updateContactPreferences;
